export default __webpack_public_path__ + "static/media/card.d5bd82c4.png";